import {useEffect} from 'react';

export function useSourcingListPoller({
  enabled,
  pollingInterval,
  doPoll,
}: {
  enabled: boolean;
  pollingInterval: number;
  doPoll: () => Promise<void>;
}) {
  // useEffect: window setInterval + visibilitychange subscription. No approved-pattern equivalent.
  useEffect(() => {
    if (!enabled) {
      return;
    }

    let intervalId: number | undefined;

    function maybePoll() {
      if (document.hidden) {
        return;
      }
      void doPoll();
    }

    function startInterval() {
      if (intervalId !== undefined) {
        window.clearInterval(intervalId);
      }
      intervalId = window.setInterval(maybePoll, pollingInterval);
    }

    // Immediate poll on enable; see README §Real-time polling.
    maybePoll();
    startInterval();

    function onVisibilityChange() {
      if (!document.hidden) {
        void doPoll();
        startInterval();
      }
    }
    document.addEventListener('visibilitychange', onVisibilityChange);

    return () => {
      if (intervalId !== undefined) {
        window.clearInterval(intervalId);
      }
      document.removeEventListener('visibilitychange', onVisibilityChange);
    };
  }, [enabled, pollingInterval, doPoll]);
}
